import React from 'react'
import { GoInfo } from 'react-icons/go'
import { Form, Col, OverlayTrigger, Tooltip, Button  } from 'react-bootstrap'

import './styles.css'

// componente input sem validacao
const SelectWithValidationInfo = ({ 
    type, 
    Col, 
    label, 
    name, 
    placeholder, 
    value, 
    error,
    handleChange,
    options,
    typeColumn="md", 
    valueColumn,
    readOnly=false,
    placement='top',
    tooltip,
    }) => (
        typeColumn === "md"
        ?
        <Col md>
            <Form.Group as={Col} controlId={name}>
                <Form.Label>
                    {label + "  "}
                    <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                            <Tooltip
                                id={`tooltip-${placement}`}
                                className="select-tooltip"
                                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>  
                                {tooltip}
                            </Tooltip>
                        }
                        >
                        <button className='controlInfo-btn-tooltip'>
                            <GoInfo />
                        </button>
                    </OverlayTrigger>    
                </Form.Label>
                <Form.Select
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    isInvalid={!!error}
                    disabled={readOnly}
                >
                    {options.map((item, index) => (<option value={item}>{item}</option>))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        </Col>
        :
        <Col xs={valueColumn}>
            <Form.Group as={Col} controlId={name}>
                <Form.Label>
                    {label + "  "}
                    <OverlayTrigger
                        className={""}
                        key={placement}
                        placement={placement}
                        overlay={
                            <Tooltip 
                                id={`tooltip-${placement}`}
                                className="select-tooltip"
                                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                                {tooltip}
                            </Tooltip>
                        }
                        >
                        <button className='controlInfo-btn-tooltip'>
                            <GoInfo />
                        </button>
                    </OverlayTrigger>    
                </Form.Label>
                <Form.Select
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    isInvalid={!!error}
                    disabled={readOnly}
                >
                    {options.map((item, index) => (<option value={item}>{item}</option>))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        </Col>
    )

export default SelectWithValidationInfo;